var paragraph_default = {
  "fontElementMap": "eMsNb",
  "elementSpacing": "eUxPq",
  "text": "eBpC0 eUxPq",
  "child": "zm9nI"
};
export {
  paragraph_default as default
};
//# sourceMappingURL=paragraph-scss.js.map
